import React from 'react'
import PropTypes from 'prop-types'
import {Box, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import CloudinaryImage from '../../../components/cloudinary-media/image'
import {Swiper, SwiperSlide} from 'swiper/react'
import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/navigation'
import {FreeMode, Navigation} from 'swiper/modules'

const ThumbnailImages = ({ids, selectedId, setSelectedId, setFetchProduct, eGiftCardsJson}) => {
    const styles = useMultiStyleConfig('GiftCertificate')
    return (
        <Box {...styles.rightBox.swiperWrapper}>
            <Swiper
                slidesPerView={'auto'}
                spaceBetween={16}
                freeMode={true}
                navigation={false}
                modules={[FreeMode, Navigation]}
                style={{paddingTop: '25px', paddingBottom: '25px'}}
            >
                {ids.map((id) => (
                    <SwiperSlide
                        key={id}
                        onClick={() => {
                            setSelectedId(id)
                            setFetchProduct(true)
                        }}
                    >
                        <Box
                            border={id === selectedId ? '1px solid' : '1px solid transparent'}
                            borderColor={id === selectedId ? 'gray.800' : 'transparent'}
                            {...styles.rightBox.thumbnailBox}
                            className="thumbnail-box"
                        >
                            {id === selectedId && <Box {...styles.rightBox.gradient} />}

                            <CloudinaryImage
                                src={eGiftCardsJson[id]}
                                alt="Thumbnail E Gift Card | Kendra Scott"
                                aspectRatio="83:104"
                                imgSizes={{base: '108px', lg: '83px'}}
                                sizes={[108, 83]}
                                styles={styles.rightBox.thumbnailImage}
                            />
                        </Box>
                    </SwiperSlide>
                ))}
            </Swiper>
        </Box>
    )
}

ThumbnailImages.propTypes = {
    ids: PropTypes.any,
    selectedId: PropTypes.string,
    setSelectedId: PropTypes.func,
    setFetchProduct: PropTypes.func,
    eGiftCardsJson: PropTypes.object
}

export default ThumbnailImages
